<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$translate"
				start
			/>
			<translate>Translations per URL segment</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-data-table
						:headers="headers"
						:items="segmentsWithTranslations"
						:sort-by="[{key: 'segment', localOrder: 'asc'}]"
					>
						<template #item.edit="props">
							<route-translation-dialog
								:segment-with-translation="props.item"
								:domain-name="domainName"
								@update:segment-with-translation="$emit('update:segmentsWithTranslations')"
							/>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>


export default {
	name: 'TranslatedSegmentList',
	props: {
		segmentsWithTranslations: {
			required: true,
			type: Array,
			default: () => [],
		},
		domainName: {
			required: true,
			type: String,
			default: '',
		}
	},
	emits: ['update:segmentsWithTranslations',],
	data () {
		return {
		};
	},

	computed: {
		headers: function () {
			return [
				{
					title: this.$gettext('Original segment'),
					value: 'segment'
				},
				{
					title: this.$gettext('How it should appear in the selected domain'),
					value: 'translation'
				},
				{
					title: '',
					value: 'edit'
				},
			];
		}
	},
};
</script>

<style scoped>

</style>
